import React from "react";
import CurrentWeather from "./CurrentWeather";
import Footer from "./Footer";

import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <h1> Anonymous Weather App </h1>
        <CurrentWeather defaultCity="Toronto" />
        <Footer />
      </div>
    </div>
  );
}
